import { render, staticRenderFns } from "./roleManage.vue?vue&type=template&id=6e8fa6a0&"
import script from "./roleManage.vue?vue&type=script&lang=js&"
export * from "./roleManage.vue?vue&type=script&lang=js&"
import style0 from "./roleManage.vue?vue&type=style&index=0&id=6e8fa6a0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports